module.exports = __webpack_public_path__ + "img/xmasParty6.5446496f.jpg";